module.exports = __webpack_public_path__ + "img/leader_ko.30b7d6bd.svg";